import { render } from "./CardCommission.vue?vue&type=template&id=2c976c95"
import script from "./CardCommission.vue?vue&type=script&lang=js"
export * from "./CardCommission.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__